import { useLayoutEffect, useState } from "react";

export function useCustomHeaderEffect() {
  const [mainLayoutPadding, setMainLayoutPadding] = useState(20);
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    let updateSize = () => {
      let header = window.document.querySelector("header");
      let height = header?.offsetHeight ?? 0;
      setHeaderHeight(height);
      setMainLayoutPadding(height && height > 68 ? height - 48 : 20);
    };

    const observer = new ResizeObserver(() => {
      updateSize();
    });

    const header = window.document.querySelector("header");
    if (header) {
      observer.observe(header);
    }

    // Cleanup when no longer needed
    return () => {
      if (header) {
        observer.unobserve(header);
      }
    };
  }, []);

  return { mainLayoutPadding, headerHeight };
}
